import { Table, Space, message, Image, Empty, Spin } from 'antd';
import constants from '../constants/constants';
import React, { useContext, useEffect, useState } from "react";
import WebLinks from '../api/WebLinks';
import { GetCustomPriorityLevelIcons, GetPriorityLevelColors } from '../globalFunctions/GlobalFunctions';
import APIUtils from '../api/APIUtils';
import Cookies from 'js-cookie';
import { CommonContext, CurrencyContext } from '../Context';

const Budgets = () => {
	const currencyContext=useContext(CurrencyContext);
	const commonContext=useContext(CommonContext);
	const [Loading,setLoading]=useState(false);
	const [data,setData]=useState([]);
	const [total,setTotal]=useState(0);
	const [priorityCheck,setPriorityCheck]=useState("f");

	const getoverallLabel=(record,index)=>{
		if (index === 0) {
			return '';
		} else if(record.budget) {
			return '(Budget)';
		} else {
			return '(Distribute)';
		}
	};

	const columns = [
		{
			dataIndex: 'suppliers',
			key: 'suppliers',
			width: '20%',
			render: (text, record, index) =>
			<>
				{index === 0 ? (<span className='uppercase font-extrabold text-lg'>Total Budget</span>) : (record.logoURL && record.logoURL!==""? <Image src={record.logoURL} preview={false} width={100}/> : <span className='uppercase font-bold text-gray-400'>{record.supplierName} Budget</span>)}
			</>
		},
		{
			dataIndex: 'budgetCategory',
			key: 'budgetCategory',
			width: '15%',
			render: (text, record, index) => 
			<span className='font-bold text-gray-400'>
				{getoverallLabel(record,index)}
			</span>,
		},
		{
			title: <span className='uppercase font-bold'>Last month</span>,
			align: "left",
			children:[
				{
					title:<span className='font-bold'>Budget</span>,
					dataIndex: 'lastMonth',
					key: 'lastMonth',
					// align:"center",
					render: (text,record) => <>{record.budget?<span className='font-extrabold'>{currencyContext.currency}{text}</span>:<span className='font-extrabold center'>-</span>}</>
				},
				{
					title: <span>(spend)</span>,
					dataIndex:'lastMonthSpend',
					key:'lastMonthSpend',
					render:(_,item) =>
					<>
					{item.budget?
					<Space size="small">
						<span>({currencyContext.currency}{item.lastMonthSpend})</span>
						{item.lastMonth>0?<span className={item.lastMonthSpend==0?'text-red-500 font-bold':'text-green-500 font-bold'}>{item.lastMonthSpentPer+"%"}</span>:null}
					</Space>
					:<span className='font-extrabold center'>-</span>}
					</>
				}
			]
		},
		{
			title: <span className='uppercase font-bold'>This month</span>,
			align: "left",
			children:[
				{
					title:<span className='font-bold'>Budget</span>,
					key: 'thisMonth',
					dataIndex: 'thisMonth',
					render: (text,record) => (
						<>{record.budget?<span className='font-extrabold'>{currencyContext.currency}{text}</span>:<span className='font-extrabold center'>-</span>}</>
					),
				},
				{
					title:<span>(spend)</span>,
					key: 'thisMonthSpend',
					dataIndex: 'thisMonthSpend',
					render: (_,item) => (
						<>{item.budget?
						<Space size="small">
							<span>({currencyContext.currency}{item.thisMonthSpend})</span>
							{item.thisMonth>0?<span className={item.thisMonthSpend==0?'text-red-500 font-bold':'text-green-500 font-bold'}>{item.thisMonthSpentPer+"%" }</span>:null}
						</Space>
						:<span className='font-extrabold center'>-</span>}</>
					),
				}
			]
		},
		{
			title: <>
				<span className='uppercase font-bold'>Next month</span>
				<br/>
				<span className='font-bold'>Budget</span>
			</>,
			key: 'nextMonth',
			dataIndex: 'nextMonth',
			render: (text,record) => (
				<>{record.budget?<span className='font-extrabold'>{currencyContext.currency}{text}</span>:<span className='font-extrabold center'>-</span>}</>
			),
		},
	];
	
	// Priority expandable sub table.
	const expandedRowRender = (record,index, indent, expanded) => {
		const byPriorityColumns = [
			{
				dataIndex: 'suppliers',
				key: 'suppliers',
				width: '21%',
				render: (text) => <span className='uppercase font-bold invisible'>{text} Budget</span>,
			},
			{
				dataIndex: 'priorityLevel',
				key: 'priorityLevel',
				width: '15.5%',
				render: (text) => <Space>
					<div className={priorityCheck==="t"?GetCustomPriorityLevelIcons(text):GetPriorityLevelColors(text)}></div>
					<span>{text}</span>
				</Space>,
			},
			{
				title: <span className='uppercase font-bold'>Last month</span>,
				align: "left",
				children:[
					{
						title:<span className='font-bold'>Budget</span>,
						dataIndex: 'lastMonth',
						key: 'lastMonth',
						render: (text) => <span className='font-extrabold'>{currencyContext.currency}{text}</span>
					},
					{
						title: <span>(spend)</span>,
						dataIndex:'lastMonthSpend',
						key:'lastMonthSpend',
						render:(_,item) =>
						<Space size="small">
							<span>({currencyContext.currency}{item.lastMonthSpend})</span>
							{item.lastMonth>0?<span className={item.lastMonthSpend>0?'text-green-500 font-bold':'text-red-500 font-bold'}>{item.lastMonthSpentPer}%</span>:null}
						</Space>
					}
				]
			},
			{
				title: <span className='uppercase font-bold'>This month</span>,
				align: "left",
				children:[
					{
						title:<span className='font-bold'>Budget</span>,
						key: 'thisMonth',
						dataIndex: 'thisMonth',
						render: (_,item) => (
						<span className='font-extrabold'>{currencyContext.currency}{item.thisMonth}</span>						),
					},
					{
						title:<span>(spend)</span>,
						key: 'thisMonthSpend',
						dataIndex: 'thisMonthSpend',
						render: (_,item) => (
							<Space size="small">
								<span>({currencyContext.currency}{item.thisMonthSpend})</span>
								{item.thisMonth>0?<span className={item.thisMonthSpend>0?'text-green-500 font-bold':'text-red-500 font-bold'}>{item.thisMonthSpentPer}%</span>:null}
							</Space>
						),
					}
				]
			},
			{
				title: <span className='uppercase font-bold'>Next month</span>,
				key: 'nextMonth',
				width: '15.5%',
				render: (_,item) => (
						<div>
							<span className='font-extrabold'>{currencyContext.currency}{item.nextMonth}</span>		
						</div>
				),
			},
		];
		const byPriorityData = record.priorityList.filter((item)=>item.priorityLevel!==10);
		return <Table columns={byPriorityColumns} dataSource={byPriorityData} size="middle" showHeader={false} pagination={false} />;
	};

	//Get Listing Data
	const getData = async(currentpage=1) =>{
		setLoading(true);
		const todayDate =new Date();
		const response = await APIUtils.apiCall('GET',WebLinks.GetBudget+commonContext.common.buyerId+"&month="+(todayDate.getMonth()+1)+"&year="+todayDate.getFullYear()+"&limit="+constants.pageSizeBudgets+"&pageNo="+currentpage);
    	if(!response.isCatch && response.resultObj.statusCode==="2000"){
			//Start: Added unique key to fix all inner tables opening together
			response.resultObj.data.map((item,index)=>{
				item.key=index;
				if(index===0){
					item.budget=true;
				}
			})
			//end
			setData(response.resultObj.data);
			setTotal(response.resultObj.getCount);
    	}else{
			setData([]);
			message.error(response.resultObj.message);
    	}
		setLoading(false);
	};
	const onchangeBudgetTable = (pagination, filters, sorter) =>{
		if(pagination){
			getData(pagination?.current);
		}
	};

  //Function to get priority list
  const getBuyerPrioritylist=async()=>{
    let url = WebLinks.GetBuyerPriorityFilters + commonContext.common.buyerId;    
    const response = await APIUtils.apiCall('GET', url);
    if (!response.isCatch && response.resultObj) {
      setPriorityCheck(response?.resultObj?.data?.length>5?"t":"f");
    } else {
      message.error(response?.resultObj?.message);
    }
  };

	//UseEffect
	useEffect(()=>{
		getBuyerPrioritylist();
		getData();
	},[])
	
	return (
		<div>
			<Spin spinning={Loading}>
				<div className='flex flex-wrap justify-between items-center gap-1'>
					<div className='uppercase font-bold text-xl'> </div>
					<span className='text-gray-400'>{constants.BudgetsMsg}</span>
				</div>
				<div className='mt-3 overflow-x-auto'>
					{data.length>0?
					<Table
						className='budgets-table'
						size="middle"
						columns={columns}
						loading={Loading}
						dataSource={data}
						// scroll={{ x: 1366, /* y: 450 */ }}
						expandable={{
							// defaultExpandedRowKeys: ['3', '4'],
							defaultExpandAllRows:true,
							expandedRowRender,
							rowExpandable: (record) => record.overallBudget === null ? false : !record.overallBudget, //record.suppliers !== 'Indeed' && record.suppliers !== 'Total' && record.suppliers !== 'Social Media',
						}}
						pagination={{
							pageSize:constants.pageSizeBudgets,
							total:total,
							onChange:onchangeBudgetTable
						}}
					/>:<Empty/>}
				</div>
			</Spin>
		</div>
	);
};

export default Budgets;